import { observer } from "mobx-react-lite";
import React, { useState } from "react";
import { Accordion, Grid, Header, Icon, Image, Label, Message, Segment } from "semantic-ui-react";
import styles from "../../../../Assessment/AssessmentInfoSlideControls/LearnMoreTemplate.module.css"

const cdnRoute = process.env.REACT_APP_CDN_ROUTE + "/family/";
const iconRoute = process.env.REACT_APP_CDN_ROUTE + "/icons/";

const WidowhoodSupportLearnMore: React.FC = () => {
  const [activeAccordionIndexes] = useState([0, 1]);

  const renderAccordionTips = () => {
    return (
      <>       
      <Grid stackable className={styles.learnMoreFullDiv} >
        <Grid.Row columns='equal' stretched className={styles.highlightsItemRow} >
          <Grid.Column stretched className={styles.hghlgtItemColFull} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
               <Image src={`${iconRoute}Candles3.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon}`} />
                <p className={styles.highlightsItemHeaderTitle} > NAVIGATING LOSS</p>
                <Header.Subheader className={styles.learnMoreAccordionText} >
                  <p className={styles.learnMoreAccordionTextEmphasis} >
                    <b> There is no roadmap or timeline for grief.</b><br/>
                     Nobody knows what losing a spouse is like until it happens, but there are a few things that can be helpful in navigating 
                     such a huge loss. </p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
        <Grid.Row stretched columns='equal' className={styles.highlightsItemRow} >
          <Grid.Column stretched container className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}MindPuzzle2.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconLarge}`} />
                <p className={styles.highlightsItemHeaderTitle} >THERAPY</p>
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                   <b> Talk to a qualified counselor or therapist.</b><br/>  A licensed mental health professional can help with navigating through
                   the complex emotions associated with losing a spouse or partner. You can find someone for the older adult by searching online 
                   for therapists in their area or asking their doctor for recommendations. </p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column width={6}  stretched className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle} `}>
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}SlowClock2.png`}  className={`${styles.highlightsItemHeaderImgEnlargeIcon} ${styles.highlightsIconMedium}`} />
                <p className={styles.highlightsItemHeaderTitle} >STAY BUSY</p>
                <Header.Subheader>  
                  <p className={styles.learnMoreAccordionText} >
                    <b> Establish a new routine.</b><br/>
                    The older adult may find themselves with newfound time on their hands and the loss of their normal routine after losing their 
                    spouse. You can encourage the older adult to stay active in their church or community or pick up a new hobby to help them occupy 
                    their time. Establishing a new routine that helps give their day purpose gives them something to look forward to each day. </p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
          <Grid.Column stretched doubling className={`${styles.highlightsItemColumn} ${styles.hghlgtItemColMiddle}`} >
            <Segment raised className={styles.highlightsItemWhiteBG} >  
              <Header as='h2' icon className={styles.highlightsItemHeader} >
                <Image src={`${iconRoute}SelfLove1.png`} className={`${styles.highlightsItemHeaderImgEnlargeIcon} `} />
                <p className={styles.highlightsItemHeaderTitle} >SELF-CARE</p>
                <Header.Subheader> 
                  <p className={styles.learnMoreAccordionText} >
                    <b>Focus on self-care.</b><br/> It is important for the older adult to make sure they are taking care of their own bodies during this 
                  difficult time. Having access to healthy meals, getting enough sleep, getting outside, and light physical activity can all be helpful 
                  during the grieving process.</p>
                </Header.Subheader>
              </Header>
            </Segment>  
          </Grid.Column>
        </Grid.Row>
      </Grid>
      </>
    );
  };


  const accordions = [
    { key: 'tips',
      index: 0,
      title: { 
        icon: <Icon name='dropdown' className={styles.learnMoreAccordionLabelTitleIcon} />, 
        content: <Label className={styles.learnMoreAccordionLabelTitle} >Tips on Coping with the Loss of a Spouse</Label> },
      content: { 
        content: (<Message className={styles.learnMoreAccordionMessageBox} content={renderAccordionTips()}/>)
      }
    }
  ];

  
  return (
    <>
      <Segment className={styles.learnMoreBackgroundImg} style = {{ backgroundImage: `url(${cdnRoute}widowhood_main.jpg)`, }}>
        <div className={styles.learnMoreModalContent}>

          <div className={styles.learnMoreAccordionFullDivGrid} >
            <div className={styles.learnMoreAccordionFullDiv} >
              <Accordion panels={accordions} className={styles.learnMoreModalAccordionGroup} defaultActiveIndex={activeAccordionIndexes} exclusive={false} />
            </div> 
          </div>  

        </div>
      </Segment>      
    </>
  );  
};

export default observer(WidowhoodSupportLearnMore);
